export const BizRuleType = {
  Event: 1,
  Notification: 2,
  Agent: 3,
  Requester: 4,
  Session: 5,
  Widget: 6,
  Others: 7,
};

export const CustomType = {
  date: "date",
  datetime: "datetime",
  dropdown: "dropdown",
  autocomplete: "autocomplete",
  numeric: "numeric",
  integer: "integer",
  slider: "slider",
  switch: "switch",
  text: "text",
  tag: "tag",
  multichoice: "multichoice",
  textarea: "textarea",
};
